import { TransferChannelType, TransferType } from "@/common/types";
import { MessagingInProgressActionButtons } from "./MessagingInProgressActionButtons";
import { closeWebchatConversation } from "@/repository/queryFns";
import { WebchatVideoCallButton } from "./WebchatVideoCallButton";

export const WebchatInProgressActionButtons = () => {
	return (
		<MessagingInProgressActionButtons
			transferType={TransferType.WebchatAgentTransfer}
			transferIVRType={TransferType.WebchatTransferToQueue}
			transferChannelType={TransferChannelType.WebChat}
			closeInteraction={closeWebchatConversation}
			enablePauseButton
			additionalActions={<WebchatVideoCallButton />}
		/>
	);
};
